import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { isAuthenticated, sendLogin, uploadFileCsv } from '../../auth/Auth';
import { getAccounts, addShopAccount } from '../../actions/Accounts';
import { addShopImage, addRelationShop } from '../../actions/Shop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import CancelButton from '../../components/atoms/CancelButton';
import {
  postUploadFile,
  postStatisticsGochi,
  postStatisticsImport,
  getUploadFile,
  getStatisticGochiStatus
} from '../../actions/AutomaticStatistics';
import { getStatisticGochiStatusData } from '../../libs/apis/AutomaticStatisticsApi';

import '../../stylesheets/csv.css';
// import { set } from 'date-fns';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  listBtn: {
    marginTop: '30px'
  },
  btnRun: {
    marginLeft: '10px',
    lineHeight: '24px'
  },
  nameFile: {
    fontSize: '14px',
    marginBottom: '10px'
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          addShopAccount,
          addShopImage,
          addRelationShop,
          getUploadFile,
          postStatisticsImport,
          postStatisticsGochi,
          getStatisticGochiStatus,
          postUploadFile
        },
        dispatch
      )
    })
  ),
  withState('csvPaypay', 'setCsvPaypay', []),
  withState('csvAlipay', 'setCsvAlipay', []),
  withState('csvVeritrans', 'setCsvVeritrans', []),
  withState('csvAtone', 'setCsvAtone', []),
  withState('csvStripeTransfer', 'SetCsvStripeTransfer', []),
  withState('csvStripePayment', 'setCsvStripePayment', []),
  withState('enableBtnImport', 'setEnableBtnImport', false),
  withState('enableBtnReport', 'setEnableBtnReport', false),
  withState('statusData', 'setStatus', []),
  withState('textSuccess', 'setTextSuccess', ''),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('openConfirmDialog', 'updateOpenConfirmDialog', false),
  withState('message', 'setMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    setEnableBtnReport,
    csvStripePayment,
    setCsvStripePayment,
    SetCsvStripeTransfer,
    csvStripeTransfer,
    setCsvPaypay,
    csvPaypay,
    setCsvAlipay,
    csvAlipay,
    setCsvVeritrans,
    csvVeritrans,
    setCsvAtone,
    csvAtone,
    // textSuccess,
    updateOpenProgress,
    openProgress,
    setLoading,
    loading,
    setMessage,
    message,
    // statusData,
    history,
    openConfirmDialog,
    updateOpenConfirmDialog
  }) => {
    function progressOkAction() {
      updateOpenProgress(false);
    }

    const handleCsvStripePayment = data => {
      if (data && data.length > 0) {
        setCsvStripePayment(oldState => [...oldState, ...data]);
      } else {
        setCsvStripePayment([]);
      }
    };

    const handleCsvStripeTransfer = data => {
      if (data && data.length > 0) {
        SetCsvStripeTransfer(oldState => [...oldState, ...data]);
      } else {
        SetCsvStripeTransfer([]);
      }
    };
    const handleCsvPaypay = data => {
      if (data && data.length > 0) {
        setCsvPaypay(oldState => [...oldState, ...data]);
      } else {
        setCsvPaypay([]);
      }
    };

    const handleCsvAlipay = data => {
      if (data && data.length > 0) {
        setCsvAlipay(oldState => [...oldState, ...data]);
      } else {
        setCsvAlipay([]);
      }
    };

    const handleCsvVeritrans = data => {
      if (data && data.length > 0) {
        setCsvVeritrans(oldState => [...oldState, ...data]);
      } else {
        setCsvVeritrans([]);
      }
    };

    const handleCsvAtone = data => {
      if (data && data.length > 0) {
        setCsvAtone(oldState => [...oldState, ...data]);
      } else {
        setCsvAtone([]);
      }
    };

    const onClickImport = async () => {
      updateOpenProgress(true);
      setLoading(true);
      const listfiles = [];
      if (csvStripePayment) {
        await Promise.all(
          csvStripePayment.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 1,
              path: data
            });
          })
        );
      }

      if (csvStripeTransfer) {
        await Promise.all(
          csvStripeTransfer.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 2,
              path: data
            });
          })
        );
      }

      if (csvPaypay) {
        await Promise.all(
          csvPaypay.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 3,
              path: data
            });
          })
        );
      }

      if (csvAlipay) {
        await Promise.all(
          csvAlipay.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 4,
              path: data
            });
          })
        );
      }

      if (csvVeritrans) {
        await Promise.all(
          csvVeritrans.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 5,
              path: data
            });
          })
        );
      }

      if (csvAtone) {
        await Promise.all(
          csvAtone.map(async file => {
            const data = await uploadFileCsv('transaction', file, '');
            listfiles.push({
              channelType: 6,
              path: data
            });
          })
        );
      }

      function getChannelTypeName(channelType) {
        switch (channelType) {
          case 1:
            return 'Stripe Payment';
          case 2:
            return 'Stripe transfer';
          case 3:
            return 'Paypay';
          case 4:
            return 'Alipay';
          case 5:
            return 'Veritrans';
          case 6:
            return 'Atone';
          default:
            return '';
        }
      }

      await actions.postUploadFile(listfiles).then(response => {
        if (response.type === 'POST_UPLOAD_FILE_SUCCESS') {
          const failedFiles = response.payload
            .filter(item => item.validateStatus === false)
            .map(item => item.channelType);
          const failedFilesUniq = [...new Set(failedFiles)];
          if (failedFilesUniq.length > 0) {
            setLoading(false);
            let failedFilesStr = '';
            failedFilesUniq.forEach(item => {
              failedFilesStr += `\n${getChannelTypeName(item)}`;
            });
            setMessage(`Upload file thất bại: ${failedFilesStr}`);
          } else {
            setLoading(false);
            setMessage('Upload file thành công');
          }
        } else {
          setLoading(false);
          setMessage('Upload không thành công');
        }
      });
    };

    const checkStatusRunReport = async () => {
      setLoading(true);
      updateOpenProgress(true);
      await actions.getUploadFile().then(async data => {
        if (data.type === 'GET_UPLOAD_FILE_SUCCESS') {
          setLoading(false);
          // const listChanel = [1, 2, 3, 4, 5];

          const listChanelGet = [];
          if (data.payload && data.payload.length > 0) {
            data.payload.forEach(item => {
              if (item.status === 4) {
                listChanelGet.push(item.channelType);
              }
            });
          }

          // const isAllChanel = listChanel.every(val =>
          //   listChanelGet.includes(val)
          // );

          const uploadSuccess = data.payload.every(val => val.status === 4);

          if (!uploadSuccess) {
            setMessage('Problem uploading file!!!');
            setLoading(false);
            return;
          }

          await actions.getStatisticGochiStatus().then(response => {
            if (response.type === 'GET_STATISTICS_GOCHI_STATUS_SUCCESS') {
              if (
                !response.payload ||
                response.payload.status !== 1
                // && isAllChanel
              ) {
                if (response.payload.status === 2) {
                  setMessage('Error when running report');
                  setLoading(false);
                }
                if (response.payload.status === 3) {
                  setMessage('Running report successfully');
                  updateOpenProgress(false);
                  updateOpenConfirmDialog(true);
                }
                setEnableBtnReport(true);
              } else {
                if (response.payload.status === 1) {
                  setMessage('Report is running');
                }
                setEnableBtnReport(false);
              }
            }
          });
        }
      });
    };

    const reCheckStatus = async () => {
      setLoading(true);
      updateOpenProgress(true);
      let result;
      for (let i = 0; i < 6; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        result = await getStatisticGochiStatusData().then(response => {
          return response;
        });
        if (result.data.status !== 1) break;
        // eslint-disable-next-line no-await-in-loop
        await new Promise(r => setTimeout(r, 10000));
      }

      console.log('result out for ', result);

      if (result.data) {
        setLoading(false);
        if (result.data.status === 1) {
          setMessage(
            'The report is running, it will take some minutes to be done, please wait and click button "CHECK RUN REPORT STATUS" to check status of report\'s running'
          );
        }

        if (result.data.status === 2) {
          setMessage('There is unexpected error when running report.');
        }

        if (result.data.status === 3) {
          updateOpenProgress(false);
          updateOpenConfirmDialog(true);
          setMessage('Runing report successfully.');
        }
      }
    };

    const onClickReport = async () => {
      setEnableBtnReport(false);
      updateOpenProgress(true);
      setLoading(true);
      await actions.postStatisticsImport().then(data => {
        if (data.type === 'POST_STATISTICS_IMPORT_SUCCESS') {
          console.log('binhdp33:', data);
        }
      });

      await actions.postStatisticsGochi().then(data => {
        if (data.type === 'POST_STATISTICS_GOCHI_SUCCESS') {
          console.log('binhdp33:', data);
        }
      });
      await reCheckStatus();
    };

    const goConfirmPage = () => {
      history.push('/automatic-statistics-confirm');
    };

    const onClear = () => {
      setCsvStripePayment([]);
      SetCsvStripeTransfer([]);
      setCsvAlipay([]);
      setCsvPaypay([]);
      setCsvVeritrans([]);
      setCsvAtone([]);
    };

    const enableBtnImport =
      csvStripePayment.length > 0 ||
      csvStripeTransfer.length > 0 ||
      csvPaypay.length > 0 ||
      csvAlipay.length > 0 ||
      csvVeritrans.length > 0 ||
      csvAtone.length > 0;

    return (
      <>
        <div className="box-create">
          <h2>Import dashboard files</h2>
          <br />
          <br />
          <div className={classes.sectionTitle}>Stripe Payment</div>
          <input
            className="csv-input"
            type="file"
            multiple
            onChange={e => {
              handleCsvStripePayment(e.target.files);
            }}
          />
          {csvStripePayment.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}
          <div className={classes.sectionTitle}>Stripe transfer</div>
          <input
            className="csv-input"
            type="file"
            multiple
            onChange={e => {
              handleCsvStripeTransfer(e.target.files);
            }}
          />
          {csvStripeTransfer.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}
          <div className={classes.sectionTitle}>Paypay</div>
          <input
            className="csv-input"
            type="file"
            multiple
            onChange={e => {
              handleCsvPaypay(e.target.files);
            }}
          />
          {csvPaypay.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}

          <div className={classes.sectionTitle}>Alipay</div>
          <input
            className="csv-input"
            type="file"
            multiple
            onChange={e => {
              handleCsvAlipay(e.target.files);
            }}
          />
          {csvAlipay.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}

          <div className={classes.sectionTitle}>Veritrans</div>
          <input
            className="csv-input"
            type="file"
            multiple
            accept=".csv"
            onChange={e => {
              handleCsvVeritrans(e.target.files);
            }}
          />
          {csvVeritrans.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}

          <div className={classes.sectionTitle}>Atone</div>
          <input
            className="csv-input"
            type="file"
            multiple
            accept=".csv"
            onChange={e => {
              handleCsvAtone(e.target.files);
            }}
          />
          {csvAtone.map(item => (
            <div className={classes.nameFile}>{item.name}</div>
          ))}

          <br />
          <br />
          <div className={classes.listBtn}>
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              onClick={onClear}
              size="large"
            >
              Clear
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              onClick={onClickImport}
              disabled={!enableBtnImport}
              size="large"
            >
              Import to DB
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              styles="marginLeft: 10px;"
              onClick={onClickReport}
              size="large"
            >
              Run report
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              onClick={checkStatusRunReport}
            >
              Check run report status
            </Button>
          </div>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            updateOpenConfirmDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <p>{message}</p>
          </DialogContent>
          <DialogActions>
            <CancelButton
              onClickAction={() => {
                updateOpenConfirmDialog(false);
              }}
              color="default"
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              styles="marginLeft: 10px;"
              onClick={goConfirmPage}
              size="sm"
            >
              Go to confirm statistics page
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
